import './index.css'

import { Component } from 'react'
import { nanoid } from 'nanoid'
import LabelMessage from '../utils/label-message'

const WAIT_INTERVAL = 2000
const TAB_KEY = 9

class TextInputComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.value,
      label: props.label,
      help: props.help,
      onFocus: props.onFocus,
      id: nanoid(),
    }
  }

  componentDidMount() {
    this.timer = null
  }

  handleChange = e => {
    clearTimeout(this.timer)

    this.setState({ value: e.target.value })

    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL)
  }

  handleKeyDown = e => {
    if (e.keyCode === TAB_KEY) this.triggerChange()
  }

  triggerChange = () => this.props.update(this.props.field, this.state.value)

  onFocus = () => this.setState({ onFocus: true })

  onBlur = () => this.setState({ onFocus: false })

  render() {
    return (
      <div className="text-input">
        <LabelMessage label={this.state.label} help={this.state.help} id={this.state.id} />

        <div>
          <input
            type="text"
            value={this.state.value}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            placeholder={this.props.placeholder}
          />

          <div
            className={`text-input-border-bottom ${this.state.onFocus ? 'active' : ''} ${
              this.props.showBorderBottom ? '' : 'display-none'
            }`}
          />
        </div>
      </div>
    )
  }
}

TextInputComponent.defaultProps = {
  field: 'field',
  value: '',
  label: '',
  help: '',
  placeholder: '',
  onFocus: false,
  showBorderBottom: true,
}

export default TextInputComponent
